// Coverage counts for copy, e.g. `${COVERAGE.chains} chains`.
// Builds overwrite this file with tooling/coverage-stats/refresh.mts. The committed
// values are the fallback: 126 chains, 1,624 apps, 14,792 tokenized assets.
export const COVERAGE = {
  chains: "100+",
  apps: "1,600+",
  tokenizedAssets: "14,000+",
} as const
